import { CommonErrorCode, UploadingProfilePictureErrorCode } from '../helpers/ErrorCodes';
import { Module } from '../Module';
import { IFormDataPostRequestParams } from '../ServerApi/types/IFormDataPostRequestParams';
import { IResult } from '../ServerApi/types/IResponse';
import { ServerService } from './ServerService';
import { IToastOptions, ToastType } from './ToasterService';

export class ProfilePictureService {

  private static maxImageSize = 5000000;
  private static supportedFormats = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'];

  public static $inject = [
    'ServerService',
    '$translate'
  ];

  constructor(private server: ServerService, private $translate: ng.translate.ITranslateService) {
  }

  public handlePictureSubmit(domainName: string, username: string, newUserImage: Blob,
                             callback: (toastOptions: IToastOptions) => void) {
    let errorMessage: string =  this.validateImage(newUserImage);
    if (errorMessage) {
      callback ({
        type: ToastType.Error,
        text: errorMessage,
      });
      return;
    }
    // send request to server
    const params: IFormDataPostRequestParams = {
      formDataFields: [
        { 'domainName': domainName },
        { 'username': username },
        { 'updateUserImageInput': newUserImage }
      ],
      method: 'updateUserImage'
    };
    const updatePromise: ng.IPromise<any> = this.server.requestPostFormDataToRestApi(params);
    updatePromise.then((result: IResult) => {
      errorMessage = this.handlePictureSubmitResult(result);
      callback(errorMessage? {
          type: ToastType.Error,
          text: errorMessage
        } : null
      );
    });
  }

  // return toaster error message for user if any
  public validateImage(userImage: Blob): string {
    // max image upload limit to be confirmed
    if (userImage.size > ProfilePictureService.maxImageSize) {
      return this.$translate.instant('uploadUserProfilePictureErrorFileLargerThan5Megabytes');
    }
    if (ProfilePictureService.supportedFormats.indexOf(userImage.type) < 0) {
      return this.$translate.instant('uploadUserProfilePictureErrorFileTypeNotSupported');
    }
    return null;
  }

  private handlePictureSubmitResult(result: any): string {
    if (!result.errors || !result.errors.length) {
      return null;
    }
    switch(result.errors[0].code) {
      case CommonErrorCode.FileSizeTooLarge:
        return this.$translate.instant('uploadUserProfilePictureErrorFileLargerThan5Megabytes');
      case UploadingProfilePictureErrorCode.InvalidImage:
        return this.$translate.instant('uploadUserProfilePictureErrorFileTypeNotSupported');
      case UploadingProfilePictureErrorCode.StorageException:
      default:
        return this.$translate.instant('uploadUserProfilePictureErrorSaveError');
    }
  }

}

Module.instance().service('ProfilePictureService', ProfilePictureService);
